import React, { useState } from 'react';
import axiosClient from '../../api/axiosClient';
import { useToast } from '../../context/ToastContext';

const ChangePassword = () => {
  const { showSuccess, showError } = useToast();
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [newUtilityPassword, setNewUtilityPassword] = useState('');
  const [saving, setSaving] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (newPassword !== confirmPassword) {
      showError('New password and confirmation do not match.');
      return;
    }

    setSaving(true);
    try {
      const res = await axiosClient.post('/auth/change-password', {
        currentPassword,
        newPassword,
        newUtilityPassword
      });

      showSuccess(res.message || 'Password changed successfully.');
      setCurrentPassword('');
      setNewPassword('');
      setConfirmPassword('');
      setNewUtilityPassword('');
    } catch (err) {
      showError(err.message || 'Error changing password.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="container-fluid p-0">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <div>
          <h3 className="fw-bold mb-0 text-dark">
            <i className="bi bi-shield-lock-fill text-primary me-2"></i> Security & Password Management
          </h3>
          <p className="text-muted small mb-0">Update your account login and administrative utility password</p>
        </div>
      </div>

      <div className="row justify-content-center">
        <div className="col-12 col-md-6 col-lg-5">
          <div className="card shadow-sm border-0">
            <div className="card-header bg-dark text-white py-3">
              <h5 className="mb-0 fw-bold">Change Password</h5>
            </div>
            <div className="card-body p-4">
              <form onSubmit={handleSubmit}>
                <div className="mb-3">
                  <label className="form-label small fw-semibold">Current Password *</label>
                  <input
                    type="password"
                    className="form-control"
                    placeholder="Enter current password"
                    value={currentPassword}
                    onChange={(e) => setCurrentPassword(e.target.value)}
                    required
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label small fw-semibold">New Password *</label>
                  <input
                    type="password"
                    className="form-control"
                    placeholder="Enter new password"
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                    required
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label small fw-semibold">Confirm New Password *</label>
                  <input
                    type="password"
                    className="form-control"
                    placeholder="Repeat new password"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    required
                  />
                </div>

                <div className="mb-4">
                  <label className="form-label small fw-semibold">Utility / Supervisor Password (Optional)</label>
                  <input
                    type="password"
                    className="form-control"
                    placeholder="Secondary supervisor authorization password"
                    value={newUtilityPassword}
                    onChange={(e) => setNewUtilityPassword(e.target.value)}
                  />
                </div>

                <button type="submit" className="btn btn-ocean w-100 py-2" disabled={saving}>
                  {saving ? 'Updating...' : 'Update Password'}
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChangePassword;
